import { render, staticRenderFns } from "./Turno.vue?vue&type=template&id=2b009c8c&lang=pug&"
import script from "./Turno.vue?vue&type=script&lang=js&"
export * from "./Turno.vue?vue&type=script&lang=js&"
import style0 from "./Turno.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b009c8c')) {
      api.createRecord('2b009c8c', component.options)
    } else {
      api.reload('2b009c8c', component.options)
    }
    module.hot.accept("./Turno.vue?vue&type=template&id=2b009c8c&lang=pug&", function () {
      api.rerender('2b009c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/Turno.vue"
export default component.exports